import React from 'react'

/**
 * Reusable flat transparent icon button — matches sayfi-frontend
 * MobileTopBarFlatIconButton / HeaderNotificationButton flat mode.
 * No background, no border, no shadow, no glass effects.
 *
 * 关联文档文件：ThemeToggle.tsx
 */
const FlatIconButton: React.FC<{
  onClick: () => void
  'aria-label': string
  title?: string
  children: React.ReactNode
  style?: React.CSSProperties
}> = ({ onClick, 'aria-label': ariaLabel, title, children, style }) => (
  <button
    type="button"
    onClick={onClick}
    style={{
      background: 'none',
      border: 'none',
      padding: 0,
      cursor: 'pointer',
      color: 'var(--app-text-secondary)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      ...style,
    }}
    className="active:opacity-70"
    aria-label={ariaLabel}
    title={title ?? ariaLabel}
  >
    {children}
  </button>
)

export default FlatIconButton
